import { FC, useEffect } from 'react';
import { IQuestionConfig } from '../core/IQuestion';
import { IGenericQuestionProvider, IQuestionViewProps } from '../core/question-provider/IQuestionProvider';
import { MiniWizardViewModel } from '../core/MiniWizardViewModel';
import { Step } from '../../Step';
import { ActivePatientEditForm } from '../../../household/patient/ActivePatientEditForm';
import { IPatient } from '../../../caremap/ICareMap';
import { useInstance } from '@meraki-internal/react-dependency-injection';
import { useSubscription } from '@meraki-internal/state';
import { PatientFormState } from '../../../avatar/PatientFormState';
import { NudgeBadge } from '../../../components/NudgeBadge';
import { createUseStyles } from 'react-jss';

const useStyles = createUseStyles({
    wrapper: {
        '& div ion-content div > h2': {
            marginBottom: 0,
            paddingBottom: 0
        }
    }
});

const questionType = 'entity-editor' as const;
type IQuestionType = typeof questionType;

type IEntityEditorQuestionProps = { };

export type IEntityEditorQuestion = IQuestionConfig<IQuestionType, IPatient, IEntityEditorQuestionProps>;

export class EntityEditorQuestionProvider implements IGenericQuestionProvider<IEntityEditorQuestion> {
    questionType = questionType;

    validate = (question: IEntityEditorQuestion) => Boolean(question.answer?.firstName?.trim());

    render = (question: IEntityEditorQuestion, wizard: MiniWizardViewModel) => {
        return <EnityEditorQuestionView question={question} wizard={wizard} />;
    };
};

export const EnityEditorQuestionView: FC<IQuestionViewProps<IEntityEditorQuestion>> = ({ question, wizard }) => {
    const classes = useStyles();

    // TODO: shouldn't be specific to patient, supposed to be generic 'Entitiy'?
    const patientForm = useInstance(PatientFormState);
    useSubscription(() => patientForm);

    useEffect(() => {
        wizard.answer(patientForm.state.patient);
    }, [patientForm.state.patient]); // eslint-disable-line react-hooks/exhaustive-deps

    return (
        <div className={classes.wrapper}>
            <Step
                question={question.questionTitle}
                subTitle={question.subTitle}
            >
                <div style={{width: '100%'}}>
                    <NudgeBadge
                        message="Be sure to add date of birth, medical conditions, allergies, and contact info to keep care info organized and easily accessible!"
                    />
                    <ActivePatientEditForm />
                </div>
            </Step>
        </div>
    );
};

